// Cave84 — Owner-only route guard (Phase 0 Day 3)
// Wraps routes that mutate state or expose owner-only configuration. Per spec
// §2 there are exactly two roles (owner | viewer); viewers reaching an owner
// route get redirected to the dashboard. Read-only routes use the AppShell's
// implicit auth gate (App.tsx switches the entire router on auth status), so
// no separate RequireAuth wrapper is needed.

import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuthStore } from '@/stores/auth.store';

interface RequireOwnerProps {
  children: ReactNode;
}

export function RequireOwner({ children }: RequireOwnerProps) {
  const role = useAuthStore((s) => s.userDoc?.role);
  const location = useLocation();

  if (role !== 'owner') {
    return <Navigate to="/" replace state={{ deniedFrom: location.pathname }} />;
  }

  return <>{children}</>;
}
